<template>
  <div class="myPromotion-container">
    <div class="btns">
      <el-button v-if="isDetail || this.tableData.records.length === 0" @click="handleBack">返回</el-button>
      <template v-else>
        <el-button type="primary" @click="handleConfirm(1)">参与</el-button>
        <el-button @click="handleConfirm(2)">不参与</el-button>
      </template>
    </div>
    <el-card shadow="never" style="margin-top: 20px">
      <mer-table :loading="tableLoading" 
        :tableConfig="tableConfigDay" 
        :tableData="tableData" 
        :pagination="pagination" 
        @SizeChange="handleSizeChange" 
        @PageChange="pageChange"
        >
      </mer-table>
    </el-card>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import { querySignUpGasConfigList, journeySignup } from '@/api/marketPromotion'


let tableConfigDay = [
  {label: '序号', prop: 'id' },
  {label: '活动编码', prop: 'activityNo' },
  {label: '参与活动距离门槛', prop: 'distanceLimitTypeName'},
  {label: '油站名称', prop: 'gasName'},
  {label: '油站编码', prop: 'gasId' },
  {label: '油号', prop: 'oilName' },
  {label: '是否支持线下扫码核销', prop: 'offlineConsumeName'},
  {label: '商品', prop: 'modelName'},
  {label: '券让利折扣', prop: 'rebateDiscount' },
  {label: '提报人', prop: 'createUser' },
  {label: '提报时间', prop: 'createTime'}
]

export default {
  mixins: [listPage],
  data () {
    return {
      tableConfigDay,
      isDetail: true,
      tableData: {
        records: [],
        total: 0
      }
    }
  },
  components: {
  },
  created () {
    console.log('this.$route.query.btnType', this.$route.query)
    this.isDetail = Number(this.$route.query.btnType) === 3
    this.refresh()
  },
  methods: {
    handleBack () {
      this.$router.go(-1)
    },
    // 覆写列表请求接口
    async refresh () {
      const signUpStatus = this.$route.query.btnType || 1
      this.tableLoading = true
      const data = { signUpStatus, ...this.pagination}
      try{
        const { code, result = [] } = await querySignUpGasConfigList(data)
        if(code !== 200) return
        this.tableData.records = result.result
        this.tableData.total = parseInt(result.totalRow)
      }catch(err){
        console.log(err)
      }finally{
        this.tableLoading = false
      }
    },
    async handleConfirm (signUpType) {
      const res = await journeySignup({ signUpType })
      if (res.code !== 200) return
      // this.$message.info('')
      this.handleBack()
    }
  }
}
</script>
<style lang="less" scoped>
  .btns {
    width: calc(100% + 20px);
    padding: 20px 0;
    margin-left: -10px;
    background: #FFFFFF;
    box-shadow: 0px 2px 2px 0px rgba(215, 215, 215, 0.4);
    text-align: right;
    padding-right: 10px;
    .el-button {
      width: 120px;
      height: 40px;
      margin-left: 10px;
    }
  }
</style>
